<template>
  <v-card v-if="loading" class="mercapromo-card" elevation="2">
    <mf-loading v-if="loading" :booleanLoader="loading" loader-type="card"></mf-loading>
  </v-card>

  <v-card v-else class="mercapromo-card" elevation="2">
    <div class="mercapromo-title-tooltip">
      <span class="mercapromo-card-title">{{ title }}</span>
      <Tooltip v-if="tooltip" :disabled="!tooltip" :message="tooltip">
        <mf-icon>info</mf-icon>
      </Tooltip>
    </div>
    <span class="mercapromo-card-subtitle text-cinza-0">{{ subtitle }}</span>

    <slot>
      <p v-if="text" class="mercapromo-big-text text-cinza-0">{{ text }}</p>
    </slot>
    <slot name="additional"></slot>
  </v-card>
</template>

<script>
import Tooltip from '@/modules/campanhas/gestao-ofertas-v2/views/components/Tooltip.vue'

export default {
  components: {
    Tooltip,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: null,
    },
    tooltip: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
}
</script>

<style scoped lang="scss">
.mercapromo-card {
  padding: 16px;
  flex: 1;
  min-width: 298px;
  display: flex;
  flex-direction: column;
  border-radius: 12px !important;

  .mercapromo-card-title {
    font-size: 20px;
    font-weight: 600;
    color: $cinza-d10;
  }

  .transparent-text {
    color: transparent;
  }

  .mercapromo-card-subtitle {
    font-size: 16px;
  }

  .text-cinza-0 {
    color: $cinza-0;
  }

  .mercapromo-title-tooltip {
    display: flex;
    justify-content: space-between;
  }

  .mercapromo-big-text {
    margin-top: 32px;
    font-size: 36px;
    margin-bottom: 0;
  }
}

@media screen and (max-width: 1400px) {
  .mercapromo-card {
    max-width: 340px;
  }
}

@media screen and (max-width: 1300px) {
  .mercapromo-card {
    min-width: 260px;
    max-width: 260px;
  }
}

@media screen and (max-width: 933px) {
  .mercapromo-card {
    min-width: 260px;
    max-width: 100%;
    min-height: 194px;
  }
}
</style>
